import { CardPreviewProps } from 'features/my-gift-cards/components/CardPreview';
import { TemplateParamsKey } from 'features/my-gift-cards/ts/CartPreviewTemplateParams';

export const mapTemplateParam = (value: CardPreviewProps['templateParams'][TemplateParamsKey]) => {
  if (typeof value === 'object') {
    return (value as Date).toLocaleDateString();
  }

  return value as string;
};
